export const idpConfigMocks = {
  IDPVersion: 'v1.0',
  BAGGAGE_CALCULATOR: {
    ALLOWANCES_BFF_URL: '/baggage/allowances',
    BAGGAGE_BFF_SERVER_TIMEOUT: '1000',
    BFF_TIMEOUT: '5000',
    CHARGES_BFF_URL: '/baggage/charges',
    MODAL_AEM_CONTENT:
      '/content/www/en_US/rsb/baggage-calculator-fragments/baggage-calculator.cfdata.json',
    OVERVIEW_AEM: '/content/www/global/en/baggage/overview.componentdata.json',
    PRODUCT_CATALOG_BFF_URL: '/baggage/product/catalog'
  },
  CANCEL_REFUND: {
    CANCEL_BFF_URL: '/tripcancel/cancel',
    CANCEL_TRIP_AEM_URL:
      '/content/www/en_US/nextgenreshop/content-fragments/cancel-trip.cfdata.json',
    CHANGE_OR_CANCEL_FLIGHT_AEM_URL:
      '/content/www/en_US/nextgenreshop/content-fragments/change-or-cancel-flights.cfdata.json',
    CONFIRMATION_AEM_URL:
      '/content/www/en_US/nextgenreshop/content-fragments/confirmation.cfdata.json',
    ORDERS_BFF_URL: '/tripcancel/orders',
    REFUND_STATUS_AEM_URL:
      '/content/www/en_US/nextgenreshop/content-fragments/refund-status.cfdata.json',
    REQUOTE_BFF_URL: '/tripcancel/requote',
    TRIPS_BFF_URL: '/tripcancel/trips',
    GET_ADDRESS_LINES: '/payment/getAddressLines',
    RESHOP_ELIGIBILITY_URL: '/shop/reshopeligibility',
    PERSONALIZED_CONTENT_URL: '/personalization-api/getpersonalizedContent'
  },
  CDC_ATTESTATION: {
    CDC_ATTESTATION_AEM_URL: '/content/www/en_US/attestation-form.cfdata.json',
    CDC_ATTESTATION_BFF_TIMEOUT: '100000',
    CDC_ATTESTATION_FLIGHT_LOOKUP_URL:
      '/travelhealthdocs/attestations/retrieve',
    CDC_UPDATE_ATTESTATION_URL: '/travelhealthdocs/attestations/update'
  },
  CDC_CONTACT_TRACING: {
    CDC_CONTACT_BFF_TIMEOUT: '30000',
    CDC_CONTACT_TRACING_AEM_URL: '/content/www/en_US/cdc-form.cfdata.json',
    CDC_CONTACT_TRACING_AEM_URL_TEST:
      '/content/dam/delta-applications/cdc/cdc_sample.json',
    CDC_CONTACT_TRACING_FLIGHT_LOOKUP_URL: '/contacttracing/contacts/retrieve',
    CDC_CONTACT_TRACING_FORM_URL: '/contacttracing/contacts/update'
  },
  COMMENTS_COMPLAINTS: {
    COMMENTS_COMPLAINTS_BFF_TIMEOUT: '120000',
    COMMENTS_COMPLAINTS_BFF_URL: '/contact/commentComplaint',
    CUSTOMER_INFO_BFF_URL: '/profilebff/customer',
    DROPDOWN_BFF_URL: '/profilebff/utility/getOptionList',
    GET_ADDRESS_FIELD_URL: '/profilebff/utility/getAddressFields',
    TICKET_HELP_CONTENT_URL: '/acctactvty/pages/mileageCredit/ticketHelp.jsp',
    TRIP_SEARCH_BFF_URL: '/contact/tripSearch',
    VALIDATE_SKYMILES_ACCOUNT_BFF_URL: '/profilebff/customer/validateAccount',
    ENABLE_KTS_FLAG: false,
    ENABLE_GLOBAL_AWS_FLAG: false
  },
  COMMON: {
    APP_AUTH_CONFIG_JSON:
      '/content/dam/delta-applications/login/auth-config.json',
    BAGGAGE_BFF_BROWSER_TIMEOUT: '5000',
    BAGGAGE_BFF_SERVER_TIMEOUT: '1000',
    CLIENT_DEVICE_TYPE_URL: '/home/devicetype',
    DASHBOARD_BFF_URL: '/login/login/getDashBrdData',
    GET_CLOSEST_DELTA_AIRPORT_CODE:
      '/pref/geoLocationService/getClosestDeltaAirportCode',
    GET_PERSONALIZED_CONTENT_URL: '/personalization-api/getPersonalizedContent',
    GET_PREDICTIVE_CITIES_URL: '/predictivetext/getPredictiveCities',
    GET_PREDICTIVE_RENTAL_CARS_URL: '/predictivetext/getPredictiveRentalCars',
    HEADER_FOOTER_AEM_URL: '/content/www/us/en.headerfooter.json',
    LOGIN_URL: '/login/loginPage',
    LOGOUT_URL: '/login/login/logout',
    LOGOUT_TIMEOUT: '5000',
    MONO_COMMON_PE_BROWSER_TIMEOUT: '2000',
    MONO_COMMON_PE_SERVER_TIMEOUT: '1000',
    PERSONALIZATION_ENGINE_URL:
      '/personalization-api/getMultiplePersonalizedContent',
    COMMON_AEM_COUNTRIES: '/content/dam/delta-com/refdata/countries.json'
  },
  ENROLLMENT: {
    ENROLLMENT_AEM_URL:
      '/content/www/accountmanagement/skymilesenrollment/enrollment.portaldata.json',
    ENROLLMENT_BANNER_AEM_URL:
      '/content/dam/delta-applications/loyalty-applications/amexBanner.json',
    ENROLLMENT_BFF_CHECK_EMAIL_ADDR_UNIQUE:
      '/enrollment/enrollment/checkEmailAddrUnique',
    ENROLLMENT_BFF_CHECK_USERNAME_UNIQUE:
      '/enrollment/enrollment/checkUsernameUnique',
    ENROLLMENT_BFF_ENROLL_CUSTOMER: '/enrollment/enrollment/EnrollCustomer',
    ENROLLMENT_BFF_GET_ADDRESS_FIELDS:
      '/enrollment/enrollment/getAddressFields',
    ENROLLMENT_BFF_GET_ENROLLMENT_INFO:
      '/enrollment/enrollment/getEnrollmentInfo',
    ENROLLMENT_BFF_GET_OPTION_LIST: '/enrollment/enrollment/getOptionList',
    ENROLLMENT_BFF_GET_PROMOTION_INFO:
      '/enrollment/enrollment/getPromotionInfo',
    ENROLLMENT_BFF_GET_REGEX_INFO: '/enrollment/enrollment/getRegexInfo',
    LOGIN_CUSTOMER_URL: '/login/login/loginCustomer',
    ENROLLMENT_BFF_GET_SECURITY_QUESTION_LIST:
      '/enrollment/enrollment/getSecurityQuestionList',
    ENROLLMENT_AEM_ERRORMESSAGES:
      '/content/www/accountmanagement/skymilesenrollment/errormessages.errormessage.json',
    ENROLLMENT_ENROLL_CUSTOMER:
      'https://loyalty-api-si.delta.com/loyaltyMember/v1/enrollment'
  },
  SEATS: {
    SEATS_ISM_FLIGHTS: '/ngcseatmap/ism/reshop/flights',
    SEATS_ISM_PASSENGER: '/ngcseatmap/ism/reshop/passengers',
    SEATS_LSM_FLIGHTS: '/ngcseatmap/lsm/reshop/flights',
    SEATS_ISM_SEATMAP: '/ngcseatmap/ism/reshop/seatmap',
    SEATS_LSM_SEATMAP: '/ngcseatmap/lsm/reshop/seatmap',
    SEATS_ISM_SAVESEATS: '/ngcseatmap/ism/reshop/saveSeats'
  },
  FAST_ACTION_BANNER: {
    FAB_AEM_URL:
      '/content/www/en_US/rsb/fabzeus/master/jcr:content/par/contentfragment.v2.fabdata.json',
    FAB_BFF_URL_APPLY_OFFER: '/enrollment/cardOffer/applyOffer',
    FAB_BFF_URL_GET_OFFER: '/enrollment/cardOffer/getOffer'
  },
  HEALTHCHECK_PASSPORT_BANNER: {
    HEALTHCHECK_BANNER_URL:
      '/content/www/en_US/healthcheck-passport.cfdata.json'
  },
  HEALTH_PASSPORT_TEST_ASSISTANT: {
    HEALTH_PASSPORT_TEST_ASSISTANT_AEM_URL:
      '/content/www/en_US/healthcheck-passport.cfdata.json',
    HEALTH_PASSPORT_TEST_ASSISTANT_BFF_TIMEOUT: '30000',
    HEALTH_PASSPORT_TEST_ASSISTANT_BFF_URL:
      '/travelhealthdocs/healthpassport/retrieve'
  },
  MESSAGING_LANDING: {
    MESSAGING_LANDING_AEM_URL: '/content/www/acs.cfdata.json'
  },
  MULTI_FACTOR_AUTHENTICATION: {
    MULTI_FACTOR_AUTHENTICATION_AEM_URL:
      '/content/www/en_US/mfa/mfa-setup.portaldata.json',
    PROFILE_GRAPHQL_ENDPOINT:
      'https://customer-api-si.delta.com/profile/graphql',
    COUNTRY_CODES: '/content/dam/delta-com/refdata/countries.json'
  },
  NOTIFICATION_BANNER: {
    NOTIFICATION_AEM_URL: '/content/www/seats/notificationconfig.model.json'
  },
  RESHOP: {
    APP_OFFER_SUMMARY: '/shop/reshopoffersummary',
    APP_RESHOP_ELIGIBILITY: '/shop/reshopeligibility',
    APP_RESHOP_FLIGHT_OFFERS: '/shop/reshopflightoffers',
    APP_SL_CHANNEL: 'sl-sho',
    BFF_BROWSER_TIMEOUT: '40000',
    BFF_SERVER_TIMEOUT: '40000',
    ERROR_MODAL_URL:
      '/content/www/en_US/air-shopping/fork-screen-error-modals.cfdata.json',
    FEATURE_FLAG_URL:
      '/content/www/en_US/air-shopping/featureflagconfig.model.json',
    MODEL_CONTENT_URL:
      '/content/www/en_US/air-shopping/reshop-model-content.data.json',
    NEXTGEN_CANCEL_URL:
      '/content/www/en_US/nextgenreshop/cancel-trip.html/cancel-trip'
  },
  SC_IROP_BANNER: {
    SC_IROP_BANNER_PE_URL: '/personalization-api/getpersonalizedContent'
  },
  SERVICE_ANIMAL_REQUEST: {
    SERVICE_ANIMAL_REQUEST_AEM_URL: '/content/www/en_US/svan-form.cfdata.json'
  },
  SITE_SEARCH: {
    SEARCH_AEM:
      '/content/dam/delta-applications/site-search/site-search-data.json',
    SEARCH_API:
      'https://www.googleapis.com/customsearch/v1/siterestrict?key=AIzaSyCVB0Y8AM7cMbWtVwTx2s02n4zymHrEFz8&cx=d232b51a93511032c&fields=promotions(title,htmlTitle,link,bodyLines/title,bodyLines/htmlTitle),searchInformation(totalResults,formattedTotalResults),items(title,htmlTitle,link,snippet,htmlSnippet)'
  },
  TRANSACTION_MANAGEMENT: {
    REFUND_PORTAL_BFF_URL: '/refunds-portal',
    REFUND_PORTAL_GRAPHQL_PATH: '/graphql',
    TRANSACTION_MANAGEMENT_AEM_URL:
      '/content/www/refundportal/en/wifi-refund.portaldata.json'
  },
  UPSELL:
    '/content/dam/delta-applications/flight-search-2/assets/json/upsellResponse.json',
  GOVERNMENT_FORM: {
    GOVERNMENT_FORM_AEM_URL: '/content/www/en_US/government_forms.cfdata.json'
  },
  SIMPLIFIED_TRAVEL_REQUIREMENTS: {
    SIMPLIFIED_TRAVEL_REQUIREMENTS_AEM_URL:
      '/content/www/en_US/custom-markets.cfdata.json'
  },
  LOGIN_MODAL: {
    LOGIN_MODAL_AEM_URL:
      '/content/www/en_US/login/login-modal.loginmodalcf.json',
    LOGIN_MODAL_AUTH_CONFIG_URL:
      '/content/dam/delta-applications/login/auth-config.json',
    LOGIN_DASHBOARD_BFF_URL: '/login/login/loginAndGetDashBrdData',
    FORGOT_LOGIN_BFF_URL: '/login/login/getProfileForCustomer',
    LOGIN_CUST_BFF_LOGIN_URL: '/login/login/loginCustomer',
    RESET_PASSWORD_EMAIL_LINK: '/login/login/sendResetPwdLink',
    RESET_PASSWORD: '/login/login/resetPassword'
  },
  SKYMILES: {
    SKYMILES_API_STATUS_TRACKER:
      'https://api.loy-mgmt-dev.aws.delta.com/loyaltyProgram/v1/statusTracker/medallionStatus',
    SKYMILES_API_FUTURE_ACTIVITIES:
      'https://api.loy-mgmt-dev.aws.delta.com/loyaltyProgram/v1/statusTracker/futureActivities',
    SKYMILES_AEM_AUTH_CONFIG:
      '/content/dam/delta-applications/nextgenskymiles/auth-config.json',
    SKYMILES_AEM_OVERVIEW_CONTENT:
      '/content/www/accountmanagement/nextgenskymiles/overview-content.skymilesdata.json',
    SKYMILES_AEM_OVERVIEW_MAIN_CONTENT:
      '/content/www/accountmanagement/nextgenskymiles/nextgen-overview.ngmyskymilesdata.json',
    SKYMILES_AEM_OVERVIEW_ERROR_MESSAGES:
      '/content/www/accountmanagement/nextgenskymiles/overview-error-messages.skymilesdata.json',
    SKYMILES_AEM_OVERVIEW_FEATURE_FLAGS:
      '/content/www/accountmanagement/nextgenskymiles/feature-flag.skymilesFeatureFlags.json',
    SKYMILES_AUTH_CONFIG_AEM_URL:
      '/content/dam/delta-applications/nextgenskymiles/auth-config.json',
    SKYMILES_API_STATUS_TRACKER_MULTI_REGION:
      'https://loyalty2-api-si.delta.com/loyaltyProgram/v2/statusTracker/medallionStatus',
    SKYMILES_API_FUTURE_ACTIVITIES_MULTI_REGION:
      'https://loyalty2-api-si.delta.com/loyaltyProgram/v2/statusTracker/futureActivities'
  }
};
